import { render, staticRenderFns } from "./OfferDetailsModal.vue?vue&type=template&id=2a1032f2&scoped=true&"
import script from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OfferDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OfferDetailsModal.vue?vue&type=style&index=0&id=2a1032f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1032f2",
  null
  
)

export default component.exports